import React from 'react';
import { Route, Switch } from 'react-router';
import { reportsRoutes } from './constants';


const ReportRoutes = () => {

  return (
		<Switch>
			{
				reportsRoutes.map((route, index) => {
					return (
						<Route
							key={index}
							path={route.path}
							exact={route.exact}
							render={() => <route.component />} />						
					)
				})
			}
		</Switch>
	);
}

export default ReportRoutes;